import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, as: Tag = "span", className = "" }) => (
  <Tag className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </Tag>
);

export const Kicker = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 font-display text-[11px] font-bold uppercase tracking-[0.3em] ${
      dark ? "text-brand-cyan" : "text-brand-blue"
    }`}
  >
    <span className="h-[6px] w-[6px] rounded-full bg-brand-gradient" aria-hidden="true" />
    {children}
  </span>
);

export const ArrowCta = ({ children, onClick, variant = "primary", testId, className = "" }) => {
  const base =
    "group inline-flex items-center gap-3 rounded-full font-display font-bold text-sm tracking-wide transition-[transform,background-color,box-shadow,color] duration-300 focus-visible:outline-none";
  const styles =
    variant === "primary"
      ? "bg-brand-gradient text-white px-7 py-4 shadow-[0_12px_36px_-10px_rgba(37,99,235,0.5)] hover:shadow-[0_16px_44px_-8px_rgba(56,189,248,0.45)] hover:-translate-y-0.5"
      : variant === "navy"
      ? "bg-navy text-white px-7 py-4 hover:bg-navy-2 hover:-translate-y-0.5"
      : "border border-navy/20 text-navy px-7 py-4 hover:border-brand-blue hover:text-brand-blue hover:-translate-y-0.5";
  return (
    <button type="button" data-testid={testId} onClick={onClick} className={`${base} ${styles} ${className}`}>
      <span>{children}</span>
      <svg viewBox="0 0 24 24" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M7 17 17 7" />
        <path d="M8 7h9v9" />
      </svg>
    </button>
  );
};
